import { render } from "./Series.vue?vue&type=template&id=1df920eb&scoped=true"
import script from "./Series.vue?vue&type=script&lang=js"
export * from "./Series.vue?vue&type=script&lang=js"

import "./Series.vue?vue&type=style&index=0&id=1df920eb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df920eb"]])

export default __exports__